module.exports = __webpack_public_path__ + "static/media/CGSocialThumb.1355f841.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/CGSocialThumb.png
// module id = 174
// module chunks = 0